export default "__VITE_ASSET__B8aiuEc5__"